<template>
  <div class="bbp-time-history">
    <div class="bbp-time-history-header">
      <div class="bbp-time-history-header__wrap">
        <div class="bbp-time-history-header__title">
          {{project.name}}
        </div>
        <div class="bbp-time-history-header-time">
          <i class="bbp-icon-clock bbp-time-history-header-time__icon"/>
          <div class="bbp-time-history-header-time__text">{{totalProjectTime}}</div>
        </div>
      </div>
      <i
        class="bbp-time-history-header__close bbp-icon-cross"
        @click="onClose"
      />
    </div>
    <VuePerfectScrollbar class="bbp-time-history-body">
        <BBPTimeHistoryItem
          v-for="(item, name) in subTimers"
          :key="name"
          :name="name"
          :dayItem="item"
          :position.sync="position"
          :isShowModal.sync="isShowModal"
          :currentItem.sync="currentItem"
        />
    </VuePerfectScrollbar>
    <transition name="bbp-fade">
      <BBPTimeHistoryModal
        v-if="isShowModal"
        :position="position"
        :currentItem="currentItem"
        :isShowModal.sync="isShowModal"
        @onButtonYes="onButtonYes"
      />
    </transition>
  </div>
</template>

<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TimerApi from '@/api/Timer/api'
import moment from 'moment'
import BBPTimeHistoryItem
  from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryItem/BBPTimeHistoryItem'
import BBPTimeHistoryModal
  from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryModal'
import {omit} from 'lodash'

export default {
  name: 'BBPTimeHistory',
  components: {
    BBPTimeHistoryModal,
    BBPTimeHistoryItem,
    VuePerfectScrollbar
  },
  props: {
    isShowHistoryTime: {
      type: Boolean,
      default: false
    },
    totalProjectTime: {
      type: String,
      default: ''
    },
    project: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    subTimers: [],
    isShowModal: false,
    position: {},
    currentItem: {}
  }),
  computed: {
    stepsList: {
      get () {
        return this.$store.getters.stepsList
      },
      set (data) {
        this.$store.dispatch('setStepsList', data)
      }
    }
  },
  methods: {
    onClose () {
      this.$emit('update:isShowHistoryTime', false)
    },
    onButtonYes () {
      const { _id, startDate, endDate } = this.currentItem
      const body = {
        startDate,
        endDate
      }
      this.updateSubTimer(body, _id, false)
    },
    async updateSubTimer (body, _id, isTotalUpdate) {
      try {
        const { data } = await TimerApi.updateSubTimer(body, _id)
        this.isShowModal = false
        const { totalTime: newTotalTime, startDate, endDate, commentId } = data
        if (isTotalUpdate) {
          this.updateTotalTimeParent(newTotalTime, _id)
          this.updateTimeStep(newTotalTime, commentId)
        } else {
          this.updatePositionStep(data)
          this.updateSubTimerList(startDate, endDate)
          this.groupBy()
        }
      } catch (err) {
        this.isShowModal = false
        console.error(err)
      }
    },
    updatePositionStep ({ project, startDate, commentId }) {
      const [ parentProject, subProject ] = project
      const currentSteps = this.stepsList[subProject || parentProject]
      const item = currentSteps.find((el) => el._id === commentId)
      if (!item) return
      item.dateStart = startDate
      currentSteps.sort((a, b) => new Date(b.dateStart) - new Date(a.dateStart))
    },
    updateTotalTimeParent (newTotalTime, _id) {
      const { subTimers = [] } = this.project
      const newSubTimers = subTimers.find((el) => el._id === _id)
      newSubTimers.totalTime = newTotalTime
      const secondsTotal = subTimers.reduce((total, current) => total + (current.totalTime || 0), 0)
      this.project.totalTime = secondsTotal
    },
    updateTimeStep (newTotalTime, commentId) {
      const { _id } = this.project
      const stepsByProject = this.stepsList[_id]
      const currentStep = stepsByProject.find((el) => el._id === commentId)
      if (!currentStep) return
      currentStep.totalTime = newTotalTime
    },
    updateSubTimerList (startDate, endDate) {
      this.deleteItem()
      const { newStartDate } = this.currentItem
      const { subTimers = [] } = this.project
      const newItem = {
        ...this.currentItem,
        startDate,
        endDate
      }
      if (this.subTimers[newStartDate]) {
        this.subTimers[newStartDate].unshift(this.currentItem)
      } else {
        this.subTimers = {
          [newStartDate]: [newItem],
          ...this.subTimers
        }
      }
      subTimers.unshift(newItem)
    },
    deleteItem () {
      const { subTimers = [] } = this.project
      const { oldStartDate, _id } = this.currentItem
      const index = this.subTimers[oldStartDate].findIndex((el) => el._id === _id)
      const currentIndex = subTimers.findIndex((el) => el._id === _id)
      if (index === -1) return
      if (currentIndex === -1) return
      this.subTimers[oldStartDate].splice(index, 1)
      subTimers.splice(currentIndex, 1)
      if (!this.subTimers[oldStartDate].length) {
        this.subTimers = omit(this.subTimers, [oldStartDate])
      }
    },
    groupBy () {
      const { subTimers = [] } = this.project
      const sort = subTimers.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
      const group = sort.reduce((res, el) => {
        const dateKey = moment(el.startDate).format('D-M-YYYY')
        if (!dateKey) return
        if (res[dateKey]) {
          res[dateKey].push(el)
        } else {
          res[dateKey] = [el]
        }
        return res
      }, {})
      this.subTimers = group
    }
  },
  watch: {
    currentItem ({ newItem, isTotalTime }) {
      if (!isTotalTime) return
      const { oldStartDate, _id, totalTime } = newItem
      const index = this.subTimers[oldStartDate].findIndex((el) => el._id === _id)
      if (index === -1) return
      this.subTimers[oldStartDate].splice(index, 1, newItem)
      this.updateSubTimer({ totalTime }, _id, true)
    }
  },
  beforeMount () {
    this.groupBy()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-time-history {
    width: 550px;
    height: auto;
    max-height: 80vh;
    padding: 20px 18px 20px 18px;
    border-radius: 8px;
    background: $color-white;
    overflow: hidden;
  }

  .bbp-time-history-header {
    display: grid;
    grid-template-columns: 1fr 50px;
    grid-gap: 0 7px;
    position: relative;
    margin: 0 0 29px 0;

    &__wrap {
      display: flex;
      align-items: flex-start;
      grid-gap: 0 7px;
      position: relative;
    }

    &__title {
      font-size: 17px;
      line-height: 20px;
      font-weight: 500;
    }

    &-time {
      display: flex;
      align-items: center;
      color: $color-denim;
      height: 20px;

      &__icon {
        font-size: 15px;
      }

      &__text {
        font-size: 12px;
        line-height: 14px;
        font-weight: 600;
      }
    }

    &__close {
      position: absolute;
      right: -7px;
      font-size: 17px;
      color: $color-silver;
      cursor: pointer;
      transition: 0.15s;

      &:hover {
        color: $color-dusty-gray;
      }
    }
  }

  .bbp-time-history-body {
    max-height: calc(80vh - 106px);
    margin: 0 -18px 0 0;
    padding: 0 18px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistory.vue